<style>
    .remark-desc {
        width          : 70px;
        display        : inline-block;
        overflow       : hidden;
        text-overflow  : ellipsis;
        white-space    : nowrap;
        vertical-align : bottom;
    }

    .edit-remark-btn {
        color  : #50bffe;
        cursor : pointer;
    }
</style>
<style lang="scss" scoped>
.el-dialog__wrapper /deep/ .el-dialog__header{
    text-align: center;
}
</style>
<template>
    <div>
        <el-dialog  title="批量编辑备注" :visible.sync="showDialog">
            <el-form ref="ruleForm" class="form-beauty" label-width="100px">
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="ruleForm.remark" :maxlength="500" type="textarea" placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="submitForm()" type="primary">保存</el-button>
                <el-button @click="showDialog = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                showDialog: false,
                preventKey: 1,
                ruleForm: {
                    rIds: '',
                    remark: ''
                },
            }
        },
        methods: {
            show (data) {
                this.preventKey = +new Date()
                this.ruleForm.rIds = data || ''
                this.ruleForm.remark = ''
                this.showDialog = true
            },
            submitForm (boolean) {
                this.$axios.post('/resume/changeRemark.api', this.ruleForm, {'X-showMessage': true}).then(res => {
                    this.showDialog = false
                    this.$emit('reload')
                }).catch(console.error)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// multiRemarkEditDialog.vue?70d288d4